<app-branding-layout>
  <ion-row>
    <ion-col class="ion-no-padding ion-margin-top">
      <ion-list class="no-margin" [inset]="true" lines="full">
        <ion-radio-group [value]="currentThemeId" (ionChange)="onThemeChange($event)">
          <ion-item>
            <ion-radio [value]="null">{{'Automatic' | translate}}</ion-radio>
          </ion-item>
          @for (availableTheme of availableThemes; track availableTheme) {
            <ion-item>
              <ion-radio [value]="availableTheme?.id">{{availableTheme.name | translate}}</ion-radio>
            </ion-item>
          }
        </ion-radio-group>
      </ion-list>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col class="ion-no-padding ion-margin-top">
      <ion-button (click)="selectTheme()" class="ion-no-margin" shape="round" expand="full">{{ 'Select' | translate }}</ion-button>
    </ion-col>
  </ion-row>

  <ion-row class="ion-justify-content-center">
    <ion-col size="auto" class="ion-no-padding ion-margin-top">
      <ion-button (click)="cancel()" class="ion-no-margin" shape="round" color="tertiary" size="small" fill="clear">{{ 'Cancel' | translate }}</ion-button>
    </ion-col>
  </ion-row>
</app-branding-layout>
